module.exports = __webpack_public_path__ + "img/american-samoa.95a96e20.svg";